// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_p3-0";
export var discountCodeInput = "_p3-1";